import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCustomerSegmentStore = defineStore('CustomerSegment', () => {
  const activeIconMessage = ref({
    segmentIds: null,
    iconMessageID: null,
    title: null
  })
  const searchParams = ref(null)

  function setActiveIconMessage(payload) {
    if (payload) {
      activeIconMessage.value.segmentIds = payload.segmentIds
      activeIconMessage.value.iconMessageID = payload.iconMessageID
      activeIconMessage.value.title = payload.title
    } else {
      activeIconMessage.value.segmentIds = null
      activeIconMessage.value.iconMessageID = null
      activeIconMessage.value.title = null
    }
  }

  function setSearchParams(state, payload) {
    searchParams.value = payload || null
  }

  return {
    activeIconMessage,
    searchParams,

    setActiveIconMessage,
    setSearchParams
  }
})
